import { render, staticRenderFns } from "./StaffApplicationReviewDetailEdit.vue?vue&type=template&id=0a854f38&scoped=true&"
import script from "./StaffApplicationReviewDetailEdit.vue?vue&type=script&lang=js&"
export * from "./StaffApplicationReviewDetailEdit.vue?vue&type=script&lang=js&"
import style0 from "./StaffApplicationReviewDetailEdit.vue?vue&type=style&index=0&id=0a854f38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a854f38",
  null
  
)

export default component.exports